import { ArrowRight, BookOpen, Info } from 'lucide-react';
import { useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

interface ModalRegrasRenovacaoProps {
  trigger?: React.ReactNode;
}

export function ModalRegrasRenovacao({ trigger }: ModalRegrasRenovacaoProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" size="sm" className="gap-2">
            <BookOpen className="h-4 w-4" />
            Como funciona
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <BookOpen className="h-5 w-5 text-primary" />
            Renovação por linha
          </DialogTitle>
        </DialogHeader>

        <div className="mt-3 space-y-3">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              O comparativo usa o plano e o valor atuais da fatura. A escolha do plano novo e o Delta são registrados separadamente em cada linha.
            </AlertDescription>
          </Alert>

          <Card className="bg-card border border-border border-l-[3px] border-l-brand-rose rounded-r-lg rounded-l-none">
            <CardContent className="grid gap-3 p-4 text-sm">
              <div className="grid grid-cols-[88px_16px_1fr] items-center gap-2">
                <span className="font-bold text-primary tabular-nums">M12–M17</span>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
                <span className="text-foreground">Pode alterar o valor, mas deve manter ou aumentar o pacote de GB atual da linha.</span>
              </div>
              <div className="grid grid-cols-[88px_16px_1fr] items-center gap-2 border-t pt-3">
                <span className="font-bold text-primary tabular-nums">M18+</span>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
                <span className="text-foreground">Pode escolher qualquer plano ativo da grade, inclusive com redução de GB.</span>
              </div>
            </CardContent>
          </Card>

          <p className="text-xs text-muted-foreground">O valor atual nunca define o pacote mínimo. A restrição de M12 a M17 considera somente os GB do pacote atual da linha.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
